module.exports = __webpack_public_path__ + "static/media/dinner4.64cd7183.png";